var map = {
	"./Correlation Analysis.png": "be54",
	"./Descriptive Analysis.png": "5adb",
	"./Indicator Comparison.png": "db7a",
	"./Multi-source Indicator Comparison.png": "6921",
	"./Predictive Analysis.png": "5966",
	"./Scatter Plot Analysis.png": "bb04",
	"./bkg.png": "edec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aceb";